export default {
  root: {
    marginTop: '-4px',
    marginBottom: '-4px',
  },
};
